import * as lib from '../lib'
import { IFetchItems, IFetchOfferGroup } from '../types'
import * as helpers from '../helpers'

export const listOfferGroup = async (
	signal: AbortSignal,
	token?: string | null,
): Promise<IFetchItems<IFetchOfferGroup>> => {
	const headers = lib.bearer(token)
	const method: string = 'GET'
	const params: lib.FetchOptions['params'] = {
		//TODO: sort after BE is ready (and remove manual sort below)
		//s: lib.sortSetup([['role.teamReport', 'asc']]),
	}
	const uri: string = 'offer/group?take=all'

	const options: lib.FetchOptions = {
		headers,
		method,
		params,
		signal,
	}
	const data = await lib.fetching<IFetchItems<IFetchOfferGroup>>(uri, options)

	return {
		items: data?.items?.sort(helpers.strComparator) ?? [],
		total: data?.items?.length ?? 0
	}
}
